@if (routerUrl) {
  <a
  class="link-icon re-group"
  [routerLink]="routerUrl"
  [fragment]="fragment"
  [state]="extraData ? extraData : null"
    [attr.role]="'link'">
  <ng-container *ngTemplateOutlet="inner"></ng-container>
</a>
} @else {
  @if (href) {
    <a  [href]="href" class="link-icon re-group" [target]="openInNewTab? '_blank' : '_self'" [attr.role]="'link'">
      <ng-container *ngTemplateOutlet="inner"></ng-container>
    </a>
  }
}

<ng-template #inner>
  <div (click)="trackIt()" class="re-flex re-flex-row re-items-center group-hover:re-text-primary group-focus:re-text-primary">
    @if (iconPosition === 'left') {
      <div>
        <div class="re-mr-15 re-text-primary"
        [ngClass]="{'re-animate-translate group-hover:-re-translate-x-5 group-focus:-re-translate-x-5' : !customIconSrc,
                    're-w-25 re-h-25' : size === 'lg', 're-w-15 re-h-15 ' : size === 's'}">
          <svg-icon class="custom-icon re-flex" [src]="customIconSrc || 'assets/icons/arrow-left.svg'"></svg-icon>
        </div>
      </div>
    }
    <div class="bold re-leading-s"
      [ngClass]="{'re-text-sm' : size === 'lg', 're-text-xs' : size === 's'}">
      {{linkText}}
    </div>
    @if (iconPosition === 'right') {
      <div>
        <div class="re-ml-15 re-text-primary"
        [ngClass]="{'re-animate-translate group-hover:re-translate-x-5 group-focus:re-translate-x-5' : !customIconSrc,
                    're-w-25 re-h-25' : size === 'lg', 're-w-15 re-h-15 ' : size === 's'}">
          <svg-icon class="custom-icon re-flex" [src]="customIconSrc || 'assets/icons/arrow-right.svg'"></svg-icon>
        </div>
      </div>
    }
  </div>

</ng-template>
